import React from 'react';

const KnowledgeBase = () => <div><h2>Knowledge Base</h2></div>;

export default KnowledgeBase;
